import { useCallback } from 'react';

import { VisitMedicalDeviceOrderCreateDraftCommand } from '@dreryk/egabinet-visit-frontend-api';

import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { useAccountAuthorizationModal } from '~libs.desktop.shared.account';

import { useVisitDocumentContext } from '../../../common/visitDocument/VisitDocumentContext';
import { medicalDevicesTranslationKeys } from '../translations';

import { useMedicalDeviceOrderPrintCommand } from './medicalDeviceOrder.hooks';
import { MedicalDeviceAllFieldsFormController } from './medicalDeviceOrder.types';

type MedicalDeviceOrderSubmitActionProps = Pick<MedicalDeviceAllFieldsFormController, 'handleSubmit'> & {
   readonly disabled: boolean;
   readonly onSuccess: VoidFunction;
};

export const MedicalDeviceOrderPrintAction = (props: MedicalDeviceOrderSubmitActionProps): JSX.Element => {
   const { executeVisitDocumentCommand } = useVisitDocumentContext();
   const { openAccountAuthorizationModal, renderAccountAuthorizationnModal } = useAccountAuthorizationModal();

   const { executeAsync: medicalDeviceOrderPrint } = useMedicalDeviceOrderPrintCommand({
      onAuthenticationRequiredFault: openAccountAuthorizationModal,
      onSuccess: props.onSuccess,
   });
   const printMedicalDeviceOrderDocument = useCallback(
      async (formData) =>
         executeVisitDocumentCommand(VisitMedicalDeviceOrderCreateDraftCommand, async (externalId) =>
            medicalDeviceOrderPrint({ data: formData, externalId: externalId })
         ),
      [executeVisitDocumentCommand, medicalDeviceOrderPrint]
   );

   return (
      <>
         <ActionBar.PrimaryButton
            label={medicalDevicesTranslationKeys.print}
            variant={ButtonVariant.SECONDARY}
            onClick={props.handleSubmit(printMedicalDeviceOrderDocument)}
            testId={'print'}
            blockingOperation={medicalDevicesTranslationKeys.savingData}
            disabled={props.disabled}
         />
         {renderAccountAuthorizationnModal({
            onAuthorization: props.handleSubmit(printMedicalDeviceOrderDocument),
         })}
      </>
   );
};
